import * as Routes from '../routing/Routes';
import { AuthRoles } from '../auth';

const BROCHURES = 'brochures';
const LOGOS = 'logos';
const MANUALS = 'manuals';
const PARTS = 'parts';
const PRODUCT_REGISTRATION = 'productRegistration';
const WARRANTY_CLAIMS = 'warrantyClaims';
const ADDITIONAL_RESOURCES = 'additionalResources';
const PRICE_LISTS = 'priceLists';

const filterAuthorizedTools = (
  tools = [],
  authUser,
  nestedToolsKey = 'subItems'
) => {
  const toolPermissions = authUser.tools;
  // users likely dont have these permissions
  const isAGIUser = AuthRoles.isAGIUser(authUser, 'roles');

  return tools.filter(tool => {
    if (isAGIUser) return true;
    const { hasToolOverride } = tool;

    const toolPermissionKeyUndefined = tool.toolPermissionKey === undefined;
    const toolHasNoPermissions =
      toolPermissionKeyUndefined && tool[nestedToolsKey] === undefined;

    const toolHasAuthorizedDropdownOptions =
      toolPermissionKeyUndefined &&
      tool[nestedToolsKey] !== undefined &&
      tool[nestedToolsKey].length > 0;

    return (
      !hasToolOverride &&
      (toolHasNoPermissions ||
        toolHasAuthorizedDropdownOptions ||
        (toolPermissions && toolPermissions[tool.toolPermissionKey]))
    );
  });
};

const routeToolPermissions = [
  {
    route: Routes.brochures,
    toolPermissionKey: BROCHURES
  },
  {
    route: Routes.logos,
    toolPermissionKey: LOGOS
  },
  {
    route: Routes.priceLists,
    toolPermissionKey: PRICE_LISTS
  },
  {
    route: Routes.manuals,
    toolPermissionKey: MANUALS
  },
  {
    route: Routes.warrantyreg,
    toolPermissionKey: PRODUCT_REGISTRATION
  },
  {
    route: Routes.additionalResources,
    toolPermissionKey: ADDITIONAL_RESOURCES
  },
  {
    route: Routes.warrantyclaims,
    toolPermissionKey: WARRANTY_CLAIMS
  },
  {
    route: '',
    toolPermissionKey: PARTS
  }
];

export {
  filterAuthorizedTools,
  routeToolPermissions,
  BROCHURES,
  LOGOS,
  MANUALS,
  PARTS,
  PRODUCT_REGISTRATION,
  ADDITIONAL_RESOURCES,
  WARRANTY_CLAIMS,
  PRICE_LISTS
};
